import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import moment from 'moment';
import Detail from './details/index.vue';

var TariffTradeList = function (_super) {
  __extends(TariffTradeList, _super);

  function TariffTradeList() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.orderListEsPoint = null;
    _this.columns = [];
    _this.loadingStatus = false;
    _this.rowSelection = {};
    _this.warehouseList = [];
    _this.deliveryMethodList = [];
    _this.selectedList = [];
    _this.searchData = _this.getInitSearchData();
    _this.lastParams = {};
    _this.total = 0;
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition(180);
    _this.detailCode = '';
    _this.statementDetail = {};
    _this.detailsVisible = false;
    _this.codeTypeEnum = [];
    return _this;
  }

  TariffTradeList.prototype.onDatetimeDefaultValueChange = function (arr) {
    if (arr.length) {
      this.searchData.begin_time = this.$util.formatDateTime(arr[0]);
      this.searchData.end_time = this.$util.formatDateTime(arr[1]);
    } else {
      this.datetimeDefaultValue = [moment(this.searchData.begin_time), moment(this.searchData.end_time)];
    }
  };

  TariffTradeList.prototype.created = function () {
    var _this = this;

    this.columns = [{
      title: this.t('单号'),
      dataIndex: 'order_number',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('总金额'),
      align: 'right',
      scopedSlots: {
        customRender: 'totalAmount'
      },
      filterEmpty: true
    }, {
      title: this.t('参考单号'),
      dataIndex: 'reference_number',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('仓库'),
      scopedSlots: {
        customRender: 'warehouseCode'
      },
      filterEmpty: true
    }, {
      title: this.t('账户编码'),
      dataIndex: 'account_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('运输方式'),
      dataIndex: 'transport_type_text',
      filterEmpty: true
    }, {
      title: this.t('费用生成时间'),
      dataIndex: 'transaction_time',
      filterEmpty: true
    }, {
      title: this.t('操作'),
      dataIndex: 'operation',
      width: 80,
      fixed: 'right',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: function onChange(selectedRowKeys, selectedRows) {
        _this.rowSelection.selectedRowKeys = _this.selectedList = selectedRowKeys;
        var pendingConfirmList = [];
      }
    };
    this.queryTariffTradeList();
    this.queryAllWarehouseList();
  };

  TariffTradeList.prototype.queryTariffTradeList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _i, _a, key, data, list, total;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            for (_i = 0, _a = Object.keys(this.searchData); _i < _a.length; _i++) {
              key = _a[_i];
              postData[key] = this.searchData[key];
            }

            this.lastParams = this.$util.deepCopy(postData);
            return [4, this.$api.finance.queryTariffTradeList(postData)];

          case 1:
            data = _b.sent().data;
            list = data.list, total = data.total;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  TariffTradeList.prototype.queryAllWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.common.queryAllWarehouseList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.warehouseList = data || [];
            return [2];
        }
      });
    });
  };

  TariffTradeList.prototype.handleViewDetail = function (item, orderNumber) {
    this.statementDetail = item;
    this.detailsVisible = true;
  };

  TariffTradeList.prototype.getInitSearchData = function () {
    return {
      field: 'order_number',
      value: undefined,
      order_number: undefined,
      reference_number: undefined,
      transport_type: undefined,
      warehouse_code: undefined,
      begin_time: undefined,
      end_time: undefined,
      page_index: 1,
      page_size: 10
    };
  };

  TariffTradeList.prototype.handlePageChange = function (page) {
    this.searchData.page_index = page;
    this.queryTariffTradeList();
  };

  TariffTradeList.prototype.handleTabChange = function (key) {
    this.initPage();
    this.queryTariffTradeList();
  };

  TariffTradeList.prototype.initPage = function () {
    this.searchData.page_index = 1;
    this.selectedList = [];
    this.rowSelection.selectedRowKeys = [];
  };

  TariffTradeList.prototype.handleSearch = function () {
    this.initPage();
    this.queryTariffTradeList();
  };

  TariffTradeList.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.getInitSearchData();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition(180);
    this.initPage();
    this.$nextTick(function () {
      return _this.queryTariffTradeList();
    });
  };

  TariffTradeList.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData = __assign({}, this.lastParams);
              delete postData.page_index;
              delete postData.page_size;
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData = {
                order_number_list: this.selectedList
              };
            }

            return [4, this.$api.finance.queryTariffTradeExport(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  TariffTradeList.prototype.handleDetail = function (record) {
    this.statementDetail = record;
    this.detailsVisible = true;
  };

  __decorate([enumData('DeliveryMethodEnum')], TariffTradeList.prototype, "deliveryMethodList", void 0);

  __decorate([enumData('Finance/TariffTradeFieldEnum')], TariffTradeList.prototype, "codeTypeEnum", void 0);

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], TariffTradeList.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([loading('loadingStatus')], TariffTradeList.prototype, "queryTariffTradeList", null);

  __decorate([userPrefPageSize('domesticStatementList')], TariffTradeList.prototype, "getInitSearchData", null);

  TariffTradeList = __decorate([Component({
    components: {
      Detail: Detail
    }
  })], TariffTradeList);
  return TariffTradeList;
}(Vue);

export default TariffTradeList;